import { z } from 'zod';

export const TV_CONTROLLER_COLLECTION = 'tvControllers';

export enum TvControllerBrand {
  ZEEVEE = 'ZEEVEE',
}

export enum TvControllerStatus {
  UNKNOWN = 'UNKNOWN',
  OK = 'OK',
  OFFLINE = 'OFFLINE',
}

export const TvControllerSchema = z.object({
  id: z.string().optional(),
  name: z.string().nonempty('Name is required').default(''),
  tags: z.array(z.string()).min(1).default([]),
  macAddress: z.string().optional(),
  ip: z
    .string()
    .regex(
      /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
      'Invalid IP address format'
    )
    .default(''),
  status: z.nativeEnum(TvControllerStatus),
  brand: z.nativeEnum(TvControllerBrand),
  channel: z.string().optional(),
  volume: z.string().optional(),
  firmwareVersion: z.string().optional(),
  uptime: z.string().optional(),
  staticImageOn: z.boolean().default(false),
  /** Written by the agent after a successful LOAD_CHANNEL_GUIDE. */
  loadedGuide: z
    .object({ id: z.string(), hash: z.string(), at: z.any().optional() })
    .nullable()
    .optional(),
});

export type TvController = z.infer<typeof TvControllerSchema>;
